<template>
  <div class="appbar">
    <div class="card-group">
      <div class="card login">
        <div class="login--body">
          <h1>Восстановление пароля</h1>
          <span class="login__title">Введите код восстановления</span>
          <span class="login__text">После отправки кода восстановления новый пароль будет отправлен на ваш email</span>
          <el-form ref="form" :model="model" :rules="rules">
            <el-form-item prop="code">
              <el-input v-model="model.code"
                        placeholder="Код восстановления" show-password>
                <i slot="prepend" class="el-icon-lock"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button :loading="loading" type="primary"
                         @click="onSubmit">Отправить
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex';

export default {
  data() {
    return {
      loading: false,
      model: {
        code: '',
      },
      rules: {
        code: [
          {required: true, message: 'Код обязателен', trigger: 'change'},
        ],
      },
    };
  },
  computed: {
    ...mapState({}),
  },
  methods: {
    ...mapActions('auth', ['sendRecoveryCode']),
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.sendRecoveryCode(this.model)
              .then(() => {
                this.loading = false;
                this.$router.replace({path: '/login'});
              })
              .catch((error) => {
                this.loading = false;
                let msg = "";
                if (error.data.data) {
                  msg = error.data.data.message
                }
                this.$notify({
                  title: 'Recovery',
                  message: msg,
                });
              });
          return true;
        }
        return false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-group {
  flex-flow: row wrap;
  display: flex;
}

.card {
  flex: 1 0;
  margin-bottom: 0;
  padding: 1.5rem
}

.card-body {
  flex: 1 1 auto;
  padding: 1.25rem;
}

.appbar {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login {
  line-height: 1.5;
  max-width: 420px;
  max-height: 450px;
  text-align: left;

  &--body {
    padding: 1.25rem;
  }

  &__title {
    display: block;
    color: #73818f;
    margin-bottom: .5rem;
  }

  &__text {
    display: block;
    color: #63c2de;
    padding-bottom: .5rem;
  }

  &__found {
    font-weight: 400;
    color: #20a8d8;
    cursor: pointer;
    position: absolute;
    right: 0;
  }
}

.register {
  padding-top: 4rem;
  line-height: 1.5;
  width: 340px;
  background-color: #20a8d8;
  color: white;

  p {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  .login__text {
    color: white;
  }
}
</style>
